var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-panel',{attrs:{"asset":_vm.asset,"hide-print-button":false,"asset-module":_vm.assetModule,"tabs":_vm.tabs,"last-update":_vm.status.lastUpdate,"notifications":_vm.notifications}})}
var staticRenderFns = []

export { render, staticRenderFns }